import ApiTournaments from '@/api/apiTournaments'
import Vue from 'vue'
import router from '../router'
import Tournament from '@/models/tournament'
import { createActionHelpers } from 'vuex-loading'
import moment from 'moment'
const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})
var arraySort = require('array-sort');

const state = {
    tournaments: [],
    tournament: new Tournament(),
    tournamentBasicInfo: null,
    registrations:[],
    tournamentResults: [],
    goals:[],
    generalTable:[],
    groupedGeneralTable:[],
    yellowCards:[],
    redCards:[],
    isCalendarEdited: false,
    requests:[],
    accessPetitions:[],
    tournamentGroups:[],
    tournamentTeamsWhitoutGroup:[],
    tournamentTeams: [],
    playersOfTeam:[]
}

const actions = {
    loadTournaments(context) {

        startLoading(context.dispatch, 'loading tournaments');
        ApiTournaments.all(tournaments => {
            context.commit('updateTournaments', tournaments)
            endLoading(context.dispatch, 'loading tournaments');
        }, error => {
            console.log('Error', error)
            endLoading(context.dispatch, 'loading tournaments');
        })
    },
    createTournament(context, tournament) {
        startLoading(context.dispatch, 'creating tournament');
        ApiTournaments.create(tournament, (response) => {
            console.log('Create', response)
            endLoading(context.dispatch, 'creating tournament');
            context.dispatch('goTournaments')
            //if(response.status === 200)
              //  router.push({ name: 'tournamenteditform', params: {tournamentID: response.data.data.id} })
        }, error => {
            console.log('Error', error)
            endLoading(context.dispatch, 'creating tournament');
        })
    },
    updateTournament(context, tournament) {
        startLoading(context.dispatch, 'loading tournament');
        ApiTournaments.update(tournament, (response) => {
            console.log('Update', response)
            endLoading(context.dispatch, 'loading tournament');
        }, error => {
            endLoading(context.dispatch, 'loading tournament');
            console.log('Error', error)
        })
    },
    pauseTournament(context, tournament) {
        startLoading(context.dispatch, 'update tournament');
        ApiTournaments.pause(tournament, (response) => {
            console.log('Pause', response)
            endLoading(context.dispatch, 'update tournament');
            context.dispatch("loadTournaments")
        }, error => {
            endLoading(context.dispatch, 'update tournament');
            console.log('Error', error)
        })
    },
    findTournament(context, tournamentID) {
        startLoading(context.dispatch, 'loading tournament');
        ApiTournaments.find(tournamentID, (tournament) => {
            console.log("tournament",tournament)
            context.commit('updateTournament', tournament)
            context.dispatch("calendarIsEdited",false)
            endLoading(context.dispatch, 'loading tournament');
        }, error => {
            console.log('Error', error)
            endLoading(context.dispatch, 'loading tournament');
        })
    },
    loadTournamentResults(context, tournamentID) {
        startLoading(context.dispatch, 'loading tournament');
        ApiTournaments.results(tournamentID, (sets) => {

            /*FIX Para asistencia*/
            for(var i in sets){
              for(var m in sets[i].matches){
                for(var p in  sets[i].matches[m].result.team_a_players){
                  let real_going = sets[i].matches[m].result.team_a_players[p].real_going
                  sets[i].matches[m].result.team_a_players[p].real_going = real_going == 1 ? true : false
                }
                for(var pa in  sets[i].matches[m].result.team_b_players){
                  let real_going_b = sets[i].matches[m].result.team_b_players[pa].real_going
                  sets[i].matches[m].result.team_b_players[pa].real_going = real_going_b == 1 ? true : false
                }
              }
            }
            /*END FIX*/
            console.log("FIXED", sets)
            context.commit('updateTournamentResults', sets)
            endLoading(context.dispatch, 'loading tournament');
        }, error => {
            console.log('Error', error)
            endLoading(context.dispatch, 'loading tournament');
        })
    },
    finalizeTournament(context, tournamentID) {
        startLoading(context.dispatch, 'finalizing tournament')
        ApiTournaments.finalize(tournamentID, response => {
            endLoading(context.dispatch, 'finalizing tournament')
            context.dispatch('findTournament', tournamentID)
        }, error => {
            console.log('Error', error)
            endLoading(context.dispatch, 'finalizing tournament')
        })
    },
    updateTournamentCalendar(context,tournament){
      startLoading(context.dispatch, 'update tournament');
      ApiTournaments.updateCalendar(tournament,(response) => {
        endLoading(context.dispatch, 'update tournament');
        context.dispatch('findTournament', tournament.id)
      }, error => {
          console.log(error)
          endLoading(context.dispatch, 'update tournament');
      })
    },
    loadGoals(context,tournamentid){
      startLoading(context.dispatch, 'loading data');
      ApiTournaments.goals(tournamentid,(response) => {
        endLoading(context.dispatch, 'loading data');
        var result = []
        for(var i in response.data.data){
          result.push(response.data.data[i])
        }

        result = result.sort(function(a, b){
          return b.goals-a.goals
        })
        for(var i in result){
          result[i].position = Number(i) + 1
        }


        context.commit("updateGoals",result)
        ///context.dispatch('findTournament', tournament.id)
      }, error => {
          console.log(error)
          endLoading(context.dispatch, 'loading data');
      })
    },
    loadGeneralTable(context,tournamentid){
      startLoading(context.dispatch, 'loading data');
      ApiTournaments.generalTable(tournamentid,(response) => {
        endLoading(context.dispatch, 'loading data');
        response.data.data = arraySort(response.data.data, ['final_points','difference_of_goals','goals'],{reverse: true});
        for(var i in response.data.data){
          response.data.data[i].position = Number(i) + 1
        }
        context.commit("updateGeneralTable",response.data.data)
        ///context.dispatch('findTournament', tournament.id)
      }, error => {
          console.log(error)
          endLoading(context.dispatch, 'loading data');
      })
    },
    loadGroupedGeneralTable(context,tournamentid){
      startLoading(context.dispatch, 'loading data');
      ApiTournaments.groupedGeneralTable(tournamentid,(response) => {
        endLoading(context.dispatch, 'loading data');
        for(var i in response.data.data){
          var group = response.data.data[i]
          group.general_table = arraySort(group.general_table, ['final_points','difference_of_goals','goals'],{reverse: true});
          for(var t in group.general_table){
            group.general_table[t].position = Number(t) + 1
          }
        }
        context.commit("updateGroupedGeneralTable",response.data.data)
        ///context.dispatch('findTournament', tournament.id)
      }, error => {
          console.log(error)
          endLoading(context.dispatch, 'loading data');
      })
    },
    loadYellowCards(context,tournamentid){
      startLoading(context.dispatch, 'loading data');
      ApiTournaments.yellowCards(tournamentid,(response) => {
        endLoading(context.dispatch, 'loading data');
        var result = []
        for(var i in response.data.data){
          result.push(response.data.data[i])
        }
        result = result.sort(function(a, b){
          return b.yellow_cards-a.yellow_cards
        })
        for(var i in result){
          result[i].position = Number(i) + 1
        }


        //console.log("loadYellowCards",response.data.data)
        context.commit("updateYellowCards",result)
      }, error => {
          console.log(error)
          endLoading(context.dispatch, 'loading data');
      })
    },
    loadRedCards(context,tournamentid){
      startLoading(context.dispatch, 'loading data');
      ApiTournaments.redCards(tournamentid,(response) => {
        endLoading(context.dispatch, 'loading data');
        /*ESTO SE TIENE QUE MANEJAR DESDE API*/
        var result = []
        for(var i in response.data.data){
          response.data.data[i].position = Number(i)+1
          result.push(response.data.data[i])
        }
        result = result.sort(function(a, b){
          return b.red_cards-a.red_cards
        })
        for(var i in result){
          result[i].position = Number(i) + 1
        }
        context.commit("updateRedCards",result)
      }, error => {
          console.log(error)
          endLoading(context.dispatch, 'loading data');
      })
    },
    captureMatchResult(context,data){
      startLoading(context.dispatch, 'loading data');
      ApiTournaments.captureResult(data.match, response =>{
        console.log("captureMatchResult",response);
        context.dispatch("loadTournamentResults",data.tournamentid)
        endLoading(context.dispatch, 'loading data');
      }, error =>{
        console.log(error)
        endLoading(context.dispatch, 'loading data');
      })
    },
    resetMatchResult(context, data) {
      console.log("here are reset match result before api");
      startLoading(context.dispatch, 'loading data');
      ApiTournaments.resetResults(data.match, response => {
        context.dispatch("loadTournamentResults", data.tournamentId);
        endLoading(context.dispatch, 'loading data');
      }, error => {
        endLoading(context.dispatch, 'loading data');
      });
    },
    calendarIsEdited(context,edit){
      context.commit("updateIsCalendarEdited",edit)
    },
    loadTournamentBasicInfo(context,tournamentId){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.tournamentBasicInfo(tournamentId, response => {
        console.log("loadTournamentBasicInfo",response)
        endLoading(context.dispatch, 'loading data')
        context.commit("updateTournamentBasicInfo",response.data.data)
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })

    },
    loadTournamentRegistrations(context,tournamentId){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.registrations(tournamentId, response => {
        console.log("loadTournamentRegistrations",response)
        endLoading(context.dispatch, 'loading data')
        context.commit("updateRegistrations",response.data.data)
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })
    },
    createRegistration(context,data){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.createRegistration(data, response => {
        console.log("createRegistration",response)
        endLoading(context.dispatch, 'loading data')
        //context.dispatch('goBack')
        if(data.callback){
          data.callback()
        }
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })
    },
    resolveRegistrations(context,data){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.resolveRegistrations(data.tournamentId,data.registrationId,data.accepted,data.ammount, response => {
        console.log("createRegistration",response)
        endLoading(context.dispatch, 'loading data')
        context.dispatch('loadTournamentRegistrations',data.tournamentId)
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })
    },
    acceptAndMarkAsPaidARegistration(context,data){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.acceptAndMarkAsPaidARegistration(data.tournamentId,data.registrationId,data.ammount, response => {
        console.log("acceptAndMarkAsPaidARegistration",response)
        endLoading(context.dispatch, 'loading data')
        context.dispatch('loadTournamentRegistrations',data.tournamentId)
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })
    },
    archiveRegistrations(context,data){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.archiveRegistration(data.tournamentId,data.registrationId, response => {
        endLoading(context.dispatch, 'loading data')
        context.dispatch('loadTournamentRegistrations',data.tournamentId)
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })
    },
    loadTournamentRequests(context,tournamentId){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.requests(tournamentId, response => {
        console.log("loadTournamentRequests",response)
        endLoading(context.dispatch, 'loading data')
        context.commit("updateRegistrations",response.data.data)
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })

    },
    loadTournamentAccessPetitions(context,tournamentId){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.accessPetitions(tournamentId, response => {
        console.log("loadTournamentAccessPetitions",response)
        endLoading(context.dispatch, 'loading data')
        context.commit("updateAccesPetitions",response.data.data)
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })
    },
    resolveAccessPetition(context,data){
      console.log("resolveAccessPetition",data)
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.resolveAccesPetition(data.tournamentId,data.petitionId,data.accepted, response => {
        console.log("resolveAccessPetition REsponse",response.data)
        endLoading(context.dispatch, 'loading data')
        context.dispatch('loadTournamentAccessPetitions',data.tournamentId)
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })
    },
    updateArbitraryPoints(context,data){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.updateArbitraryPoints(data.tournamentId,data.teamId,data.finalPoints, response => {
        console.log("loadTournamentAccessPetitions",response)
        endLoading(context.dispatch, 'loading data')
        if(data.tournamentMode == "normal"){
          context.dispatch("loadGeneralTable",data.tournamentId)
        }else if(data.tournamentMode == "groups"){
          context.dispatch("loadGroupedGeneralTable",data.tournamentId)
        }

      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })
    },
    resolvePlayerOfficialInfo(context,data){
      startLoading(context.dispatch, 'loading data')
      ApiTournaments.resolvePlayerOfficialInfo(data.tournamentId,data.playerId,data.status, response => {
        endLoading(context.dispatch, 'loading data')
        context.dispatch("loadPlayersOfTeam",data)
      }, error => {
        console.log(error)
        endLoading(context.dispatch, 'loading data')
      })
    },
    downloadAcceptPlayersPdf(context,data){
      startLoading(context.dispatch, 'loading pdf')
      ApiTournaments.downloadAcceptPlayersPdf(data.tournamentId,data.teamId, response => {
        endLoading(context.dispatch, 'loading pdf')
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'players.pdf');
        document.body.appendChild(link);
        link.click();
      }, error => {
        endLoading(context.dispatch, 'loading pdf')
        console.log(error)
      })
    },
    createGroup(context,data){
      startLoading(context.dispatch, 'create group')
      ApiTournaments.createGroup(data.tournamentId,data.groupName, response => {
        endLoading(context.dispatch, 'create group')
        context.dispatch("loadTournamentTeams",data.tournamentId)
        console.log(response)
      }, error => {
        endLoading(context.dispatch, 'create group')
        console.log(error)
      })
    },
    editGroup(context,data){
      startLoading(context.dispatch, 'edit group')
      ApiTournaments.editGroup(data.tournamentId,data.groupId,data.groupName, response => {
        endLoading(context.dispatch, 'edit group')
        context.dispatch("loadTournamentTeams",data.tournamentId)
      }, error => {
        endLoading(context.dispatch, 'edit group')
        console.log(error)
      })
    },
    removeGroup(context,data){
      startLoading(context.dispatch, 'remove group')
      ApiTournaments.removeGroup(data.tournamentId,data.groupId, response => {
        endLoading(context.dispatch, 'remove group')
        context.dispatch("loadTournamentTeams",data.tournamentId)
      }, error => {
        endLoading(context.dispatch, 'remove group')
        console.log(error)
      })
    },
    loadTournamentTeams(context, tournamentId){
      startLoading(context.dispatch, 'load teams')
      ApiTournaments.teams(tournamentId, response => {
        endLoading(context.dispatch, 'load teams')
        context.commit("updateTournamentTeams",response.data.data)
      }, error => {
        endLoading(context.dispatch, 'load teams')
        console.log(error)
      })
    },
    editTeamGroup(context,data){
      startLoading(context.dispatch, 'update group')
      ApiTournaments.editTeamGroup(data.tournamentId,data.groupId,data.teamId, response => {
        endLoading(context.dispatch, 'update group')
        context.dispatch("loadTournamentTeams",data.tournamentId)
      }, error => {
        endLoading(context.dispatch, 'update group')
        console.log(error)
      })
    },
    loadPlayersOfTeam(context,data){
      //context.commit("updatePlayersOfTeam",[])
      startLoading(context.dispatch, 'load players of teams')
      ApiTournaments.playersOfTeam(data.tournamentId,data.teamId, response => {
        endLoading(context.dispatch, 'load players of teams')
        context.commit("updatePlayersOfTeam",response.data.data)
      }, error => {
        context.commit("updatePlayersOfTeam",[])
        endLoading(context.dispatch, 'load players of teams')
        console.log(error)
      })
    },
    resetArbitraryPoints(context, data) {
      startLoading(context.dispatch, 'reseting arbitrary points')
      console.log('Hola');
      ApiTournaments.resetArbitraryPoints(data.tournamentId, data.teamId, response => {
        console.log(data.tournamentMode);
        console.log('acabe');
        if(data.tournamentMode == "normal"){
          context.dispatch("loadGeneralTable",data.tournamentId)
        }else if(data.tournamentMode == "groups"){
          context.dispatch("loadGroupedGeneralTable",data.tournamentId)
        }
        endLoading(context.dispatch, 'reseting arbitrary points')
      }, error => {
        endLoading(context.dispatch, 'reseting arbitrary points')
        console.log();
      })
    }
}

const mutations = {
    updateTournaments(state, tournaments){
        state.tournament = new Tournament()
        state.tournaments = tournaments
    },
    updateTournament(state, tournament){
        state.tournament = tournament
    },
    updateGoals(state,data){
      state.goals = data
    },
    updateGeneralTable(state,data){
      state.generalTable = data
    },
    updateGroupedGeneralTable(state,data){
      state.groupedGeneralTable = data
    },
    updateYellowCards(state,data){
      state.yellowCards = data
    },
    updateRedCards(state,data){
      state.redCards = data
    },
    updateTournamentResults(state,data){
      state.tournamentResults = data
    },
    updateIsCalendarEdited(state,data){
      state.isCalendarEdited = data
    },
    updateTournamentBasicInfo(state,data){
      state.tournamentBasicInfo = data
    },
    updateRegistrations(state,data){
      state.registrations = data
    },
    updateAccesPetitions(state,data){
      state.accessPetitions = data
    },
    updateTournamentMatches(state,data){
      if(data.serverResponse.length == data.matches.length){
        let total = data.serverResponse.length
        for(var i = 0; i < total; i++){
          let match = data.matches[i]
          let serverMatch = data.serverResponse[i]
          if(serverMatch.available == true || serverMatch.tournament_id == state.tournament.id){
            state.tournament.sets[match.setIndex].matches.push(match)
          }

        }
      }
    },
    updateTournamentTeams(state,data){
      state.tournamentGroups = data.grouped_teams
      state.tournamentTeamsWhitoutGroup = data.other_teams
      var tournamentTeams = []
      for(var i in data.grouped_teams){
        let group = data.grouped_teams[i]
        for(var t in group.teams){
          group.teams[t].groupName = group.name
          tournamentTeams.push(group.teams[t])
        }
      }
      for(var i in data.other_teams){
        data.other_teams[i].groupName = ""
        tournamentTeams.push(data.other_teams[i])
      }
      state.tournamentTeams = tournamentTeams
    },
    updatePlayersOfTeam(state,data){
      state.playersOfTeam = data
    }
}
/*generalTable:[],
yellowCards:[],
redCards:[]*/
const getters = {
    tournaments(state) {
        return state.tournaments
    },
    currentTournament(state) {
        return state.tournament
    },
    currentGoals(state){
      return state.goals
    },
    currentGeneralTable(state){
      return state.generalTable
    },
    currentGroupedGeneralTable(state){
      return state.groupedGeneralTable
    },
    currentYellowCards(state){
      return state.yellowCards
    },
    currentRedCards(state){
      return state.redCards
    },
    currentTournamentResults(state){
      return state.tournamentResults
    },
    isCalendarEdited(state){
      return state.isCalendarEdited
    },
    getTournamentBasicInfo(state){
      return state.tournamentBasicInfo
    },
    getRegistrations(state){
      return state.registrations
    },
    currentAccessPetitions(state){
      return state.accessPetitions
    },
    currentTournamentGroups(state){
      return state.tournamentGroups
    },
    currentTournamentTeamsWhitoutGroup(state){
      return state.tournamentTeamsWhitoutGroup
    },
    currentTournamentTeams(state){
      return state.tournamentTeams
    },
    currentPlayersOfTeam(state){
      return state.playersOfTeam
    }

}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/tournaments.js